import React, { useEffect, useState, useContext } from "react";
import QRCode from "qrcode.react";
import toastError from "../../errors/toastError";
import { makeStyles } from "@material-ui/core/styles";
import { Dialog, DialogContent, Paper, Typography } from "@material-ui/core";
import api from "../../services/api";
import { socketConnection } from "../../services/socket";
import { AuthContext } from "../../context/Auth/AuthContext";

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    borderRadius: 12,
    maxWidth: 420,
    padding: theme.spacing(2, 1.5),
    backgroundColor: theme.palette.background.paper,
  },
  dialogContent: {
    padding: theme.spacing(0, 1),
    "&:first-child": {
      paddingTop: theme.spacing(1),
    },
  },
  contentColumn: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
  },
  instructionsBlock: {
    width: "100%",
    textAlign: "center",
    marginBottom: theme.spacing(1),
  },
  title: {
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.h5.fontSize,
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.text.primary,
    marginBottom: 0,
  },
  qrCodeContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  helpText: {
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.body2.fontSize,
    textAlign: "center",
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5),
    "& a": {
      color: theme.palette.primary.main,
      textDecoration: "none",
      "&:hover": {
        color: theme.palette.primary.dark,
        textDecoration: "underline",
      },
    },
  },
}));

const QrcodeModal = ({ open, onClose, whatsAppId }) => {
  const [qrCode, setQrCode] = useState("");
  const { user } = useContext(AuthContext);
  const classes = useStyles();

  useEffect(() => {
    const fetchSession = async () => {
      if (!whatsAppId) return;

      try {
        const { data } = await api.get(`/whatsapp/${whatsAppId}`);
        setQrCode(data.qrcode);
      } catch (err) {
        toastError(err);
      }
    };
    fetchSession();
  }, [whatsAppId]);

  useEffect(() => {
    if (!whatsAppId) return;
    const companyId = user.companyId;
    const socket = socketConnection({ companyId, userId: user.id });

    socket.on(`company-${companyId}-whatsappSession`, (data) => {
      if (data.action === "update" && data.session.id === whatsAppId) {
        setQrCode(data.session.qrcode);
      }

      if (data.action === "update" && data.session.qrcode === "") {
        onClose();
      }
    });

    return () => {
      socket.disconnect();
    };
  }, [whatsAppId, onClose, user]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      scroll="paper"
      classes={{ paper: classes.dialogPaper }}
    >
      <DialogContent className={classes.dialogContent}>
        <Paper elevation={0} className={classes.contentColumn}>
          <div className={classes.instructionsBlock}>
            <Typography className={classes.title}>
              Conectar seu Whatsapp
            </Typography>
          </div>

          <div className={classes.qrCodeContainer}>
            {qrCode ? (
              <QRCode value={qrCode} size={256} />
            ) : (
              <Typography variant="body2" color="textSecondary">
                Aguardando pelo QR Code
              </Typography>
            )}
          </div>
        </Paper>

        <Typography className={classes.helpText}>
          <a href="https://faq.whatsapp.com/1317564962315842/?cms_platform=web" target="_blank" rel="noopener noreferrer">
            Precisa de ajuda para começar?
          </a>
        </Typography>
      </DialogContent>
    </Dialog>
  );
};

export default React.memo(QrcodeModal);
